import { Link } from 'react-router-dom'
import PublicLayout from '../components/layout/PublicLayout'

export default function About() {
  return (
    <PublicLayout>
      <article className="mx-auto max-w-3xl px-6 py-16">
        <p className="font-display text-sm font-bold uppercase tracking-widest text-[var(--accent-teal)]">About</p>
        <h1 className="font-display mt-2 text-4xl font-extrabold leading-tight md:text-5xl">
          A tracker that respects your privacy.
        </h1>
        <p className="mt-6 text-lg leading-relaxed text-[var(--text-secondary)]">
          wlns.app is a private fitness &amp; nutrition log. It exists because most trackers ask for an account, an
          email, and a slice of your attention — then monetise your data or hide the useful parts behind a subscription.
          We wanted the opposite: open it, log, and get on with your day.
        </p>

        <h2 className="font-display mt-12 text-2xl font-bold">No account, by design</h2>
        <p className="mt-3 leading-relaxed text-[var(--text-secondary)]">
          Instead of a username and password, your log lives at a private web address built from a few random words —
          your <em>key</em>. Bookmark it and it's yours. There's no sign-up form, no email verification, and nothing to
          forget. If you want an extra layer, you can add an optional password lock with email-based reset.
        </p>

        <h2 className="font-display mt-12 text-2xl font-bold">One place for in and out</h2>
        <p className="mt-3 leading-relaxed text-[var(--text-secondary)]">
          Most apps track either workouts or food. wlns.app does both — cardio, weights and general exercise on the
          “out” side, and food &amp; drink on the “in” side — and keeps them as separate, honest metrics. Energy burned
          and energy consumed are never quietly blended together.
        </p>

        <h2 className="font-display mt-12 text-2xl font-bold">Built to be quick</h2>
        <p className="mt-3 leading-relaxed text-[var(--text-secondary)]">
          Logging food is usually the friction that kills a habit. Here you just type what you ate in plain language and
          AI does the breakdown — calories, macros and micronutrients — for you to confirm. The whole point is to make
          the right thing the easy thing.
        </p>

        <h2 className="font-display mt-12 text-2xl font-bold">Who's behind it</h2>
        <p className="mt-3 leading-relaxed text-[var(--text-secondary)]">
          wlns.app is built by the developers at{' '}
          <a href="https://sourcecode.com.au" target="_blank" rel="noopener noreferrer" className="font-mono font-bold text-[var(--text-primary)] hover:underline">
            source<span className="text-[#3b82f6]">[</span>code<span className="text-[#3b82f6]">]</span>
          </a>
          , funded by use rather than ads or data sales. A small Pro tier may arrive to cover the cost of the AI
          nutrition lookups — casual use stays free. Questions or ideas?{' '}
          <Link to="/contact" className="text-[var(--accent-teal)] underline">Get in touch</Link>.
        </p>

        <div className="mt-12 flex flex-wrap gap-3">
          <Link to="/how-it-works" className="btn btn-secondary">How it works</Link>
          <Link to="/features" className="btn btn-secondary">Explore features</Link>
        </div>

        <p className="mt-10 text-xs text-[var(--text-secondary)]">
          wlns.app provides general information and estimates — it is not medical advice.
        </p>
      </article>
    </PublicLayout>
  )
}
